import Styles from "./Accuracy.module.scss";
import clsx from "clsx";
import MenuVTC from "../../../Share/Component/MenuVtc";
import Loading from "../../../Share/Component/Loading";
import useClientAccuracy from "../../../Hooks/useClientAccuracy";
import { LoginInput } from "../../../Components/Atoms/LoginInput";
import { Controller } from "react-hook-form";
import ReCaptcha from "../../../Components/Molecules/ReCaptcha";

function Accuracy() {
  const {
    control,
    handleSubmit,
    loading,
    version,
    reCaptchaV2,
    isLoadReCaptChaV3,
    recaptchaLoading,
    recaptchaError,
    isDefaultV3,
  } = useClientAccuracy();

  return (
    <div className={clsx(Styles.main)}>
      {loading ? <Loading /> : null}
      <div className={clsx(Styles.formBox)}>
        <div className={clsx(Styles.formValue)}>
          <h2>QUÊN MẬT KHẨU</h2>
          <form onSubmit={handleSubmit} className={clsx(Styles.form)}>
            <Controller
              name="accountName"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="TÊN TÀI KHOẢN"
                  id="accountName"
                  value={field.value}
                  onChange={(e) => {
                    field.onChange(e.target.value.toLowerCase());
                  }}
                  error={error}
                />
              )}
            />
            <Controller
              name="phoneNumber"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <LoginInput
                  label="SỐ ĐIỆN THOẠI"
                  name="phoneNumber"
                  id="phoneNumber"
                  value={field.value}
                  onChange={field.onChange}
                  error={error}
                  type="tel"
                />
              )}
            />
            <ReCaptcha
              version={version}
              isDefaultV3={isDefaultV3}
              reCaptchaV2={reCaptchaV2}
              recaptchaLoading={recaptchaLoading}
              recaptchaError={recaptchaError}
              isLoadReCaptChaV3={isLoadReCaptChaV3}
            />
            <button className={clsx(Styles.btnSubmit)} type="submit" disabled={loading}>
              Xác nhận
            </button>
          </form>
        </div>
      </div>
      <MenuVTC />
    </div>
  );
}
export default Accuracy;
